// @flow

export default function(t: Function) {
  return {
    absenceType: {
      "ui:title": t("ABSENCE_TYPES"),
      "ui:options": {
        description: t("ABSENCE_TYPES_DESCRIPTION"),
      },
    },
    timePeriodAbsencesCanBeReopened: {
      "ui:widget": "seconds-as-days-input",
      "ui:title": t("TIME_PERIOD_TO_REOPEN"),
      "ui:options": {
        description: t("TIME_PERIOD_TO_REOPEN_DESCRIPTION"),
      },
    },
    timeInAdvanceAbsenceCanBeOpened: { "ui:widget": "hidden" },
    absenceRecordingUnits: { "ui:widget": "hidden" },
    includeFitDateCaptureEnabled: { "ui:widget": "hidden" },

    allowEmployeesReopenAbsences: {
      "ui:widget": "switch-button",
      "ui:title": t("ALLOW_ABSENCE_REOPEN"),
      "ui:options": {
        labels: [
          { label: t("ACTIVE"), value: true },
          { label: t("INACTIVE"), value: false },
        ],
        description: t("ALLOW_ABSENCE_REOPEN_DESCRIPTION"),
      },
    },
    announcement: { "ui:widget": "hidden" },
    captureAbsenceBankHolidays: {
      "ui:widget": "switch-button",
      "ui:title": t("RECORD_BANK_HOLIDAYS"),
      "ui:options": {
        labels: [
          { label: t("ACTIVE"), value: true },
          { label: t("INACTIVE"), value: false },
        ],
        description: t("RECORD_BANK_HOLIDAYS_DESCRIPTION"),
      },
    },
    phasedRtwDaysRecording: { "ui:widget": "hidden" },
    rtwDiscussionType: { "ui:widget": "hidden" },
    taskKpiExcludeHolidays: { "ui:widget": "hidden" },
    taskKpiExcludeWeekends: { "ui:widget": "hidden" },
    medicalOnly: { "ui:widget": "hidden" },
    obligatedReasonDisclosure: { "ui:widget": "hidden" },
    authorisationStatus: { "ui:widget": "hidden" },
    authorisationStatusReminder: { "ui:widget": "hidden" },
    authorisationRequiredAuthorisationKpi: { "ui:widget": "hidden" },
    allowEmployeeToOpenAndCloseAbsencesInSameTransaction: { "ui:widget": "hidden" },
    allowEmployeeToUpdateAndCloseAbsencesInSameTransaction: { "ui:widget": "hidden" },
    minimumAbsenceDuration: {
      "ui:title": t("MINIMUM_ABSENCE_DURATION"),
      "ui:options": {
        description: t("MINIMUM_ABSENCE_DURATION_DESCRIPTION"),
      },
    },
    timeInAdvanceAbsencesCanClose: {
      "ui:title": t("ADVANCE_ABSENCE_CLOSING"),
      "ui:options": {
        description: t("ADVANCE_ABSENCE_CLOSING_DESCRIPTION"),
      },
    },
    "ui:order": [
      "absenceType",
      "captureAbsenceBankHolidays",
      "allowEmployeesReopenAbsences",
      "timePeriodAbsencesCanBeReopened",
      "minimumAbsenceDuration",
      "timeInAdvanceAbsencesCanClose",
      "*",
    ],
  };
}
